/**
 * Reads the CSRF token the API set at sign-in (worklist task 150).
 *
 * The session cookie is HttpOnly and cannot be read here, which is the point
 * of task 149. This one is deliberately readable: the page must echo it in a
 * header, and that is precisely what another site cannot do — it can cause a
 * request to be sent with our cookies, but it cannot read them to build the
 * matching header.
 */
const CSRF_COOKIE = "lgv_csrf";

export function getCsrfToken(): string | null {
  if (typeof document === "undefined") return null;

  for (const part of document.cookie.split(";")) {
    const eq = part.indexOf("=");
    if (eq < 1) continue;
    if (part.slice(0, eq).trim() !== CSRF_COOKIE) continue;
    try {
      return decodeURIComponent(part.slice(eq + 1).trim());
    } catch {
      return part.slice(eq + 1).trim();
    }
  }
  return null;
}

/**
 * Header bag for a state-changing request. Returns an empty object when signed
 * out, rather than a key with an undefined value — the annotation matters,
 * because an inferred union of "token present" and "token absent" is not
 * assignable to Record<string, string> at the call sites that spread it.
 */
export function csrfHeaders(): Record<string, string> {
  const token = getCsrfToken();
  return token ? { "X-CSRF-Token": token } : {};
}
